import React from 'react';
import { CheckIcon } from 'lucide-react';
interface OptionRowProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  description?: string;
  className?: string;
}

/**
 * Large single-select row for one-question-at-a-time screens. Selection is
 * carried by a check mark and border weight, not colour alone.
 */
export function OptionRow({
  selected,
  onSelect,
  title,
  description,
  className = ''
}: OptionRowProps) {
  return <button type="button" role="radio" aria-checked={selected} onClick={onSelect} className={`flex min-h-tap w-full items-start gap-3 rounded-field border px-4 py-3.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${selected ? 'border-primary bg-primary-soft' : 'border-rule bg-card hover:border-ink-subtle'} ${className}`} data-id="element-539" data-mp="dz9jzii0mckf">
      <span aria-hidden="true" className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-pill border ${selected ? 'border-primary bg-primary' : 'border-rule bg-card'}`} data-id="element-540" data-mp="1tf8f9t6jae39">
        {selected ? <CheckIcon className="h-3.5 w-3.5 text-on-primary" data-id="element-541" data-mp="1xop8hav8whdn" /> : null}
      </span>
      <span className="flex flex-col gap-0.5" data-id="element-542" data-mp="1xmmdsdj5e02l">
        <span className="text-body font-medium text-ink" data-id="element-543" data-mp="22o1szoyn9cd2">{title}</span>
        {description ? <span className="text-small text-ink-muted" data-id="element-544" data-mp="150t5xpizvv8y">{description}</span> : null}
      </span>
    </button>;
}